export class PublicPortalHelper {
    public static handleCancelNavigationCallback = (router, adminAsWalkin, serviceId, targetProfileId) => {
      router.navigate([`/services/workspace`]);
    }
}